export default __webpack_public_path__ + "static/media/Shot_4.0000.8039a2a8.png";